;(() => {
  const thumbnailProductSlider = new Swiper('[data-product-slider-thumbs]', {
    slidesPerView: 4,
    spaceBetween: 15,
    loop: false,
    navigation: {
      nextEl: '.product__thumb-arrow--next',
      prevEl: '.product__thumb-arrow--prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 8,
      },
      0: {
        slidesPerView: 0,
      },
    },
  })

  const mainProductSlider = new Swiper('[data-product-slider]', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: false,
    thumbs: {
      swiper: thumbnailProductSlider,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1.5,
      },
    },
  })
  thumbnailProductSlider.on('navigationNext', () => {
    mainProductSlider.slideNext()
  })
  thumbnailProductSlider.on('navigationPrev', () => {
    mainProductSlider.slidePrev()
  })
})()
